import { type CapturePerfSink } from '../ports/perf';
import { getConfiguredPerfSink } from './configuration';

// Late-binding delegate over the configured performance sink — resolved per
// call, covering checkpoint append and terminal start results.
export const capturePerf: CapturePerfSink = {
  appendStartRecordingCheckpoint: (params) =>
    getConfiguredPerfSink().appendStartRecordingCheckpoint(params),
  cancelStartRecordingTracking: () =>
    getConfiguredPerfSink().cancelStartRecordingTracking(),
  finishStartRecordingTrackingFailure: (error) =>
    getConfiguredPerfSink().finishStartRecordingTrackingFailure(error),
};
